var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _path10, _path11, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpened(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6526 39.89L12.0226 41.08C9.96456 40.66 8.18656 39.344 7.36056 37.608C6.53456 39.344 4.75656 40.66 2.69856 41.08L2.08256 39.89C4.57456 39.428 6.60456 37.482 6.60456 35.48V34.528H8.13056V35.48C8.13056 37.496 10.1606 39.442 12.6526 39.89ZM1.69056 43.544H13.1426V44.734H1.69056V43.544ZM24.9575 33.73V41.892H23.5015V33.73H24.9575ZM18.6855 35.102C17.6355 35.102 16.9075 35.564 16.9075 36.32C16.9075 37.076 17.6355 37.538 18.6855 37.538C19.7355 37.538 20.4495 37.076 20.4495 36.32C20.4495 35.564 19.7355 35.102 18.6855 35.102ZM18.6855 38.616C16.8095 38.616 15.5075 37.692 15.5075 36.32C15.5075 34.934 16.8095 34.024 18.6855 34.024C20.5475 34.024 21.8495 34.934 21.8495 36.32C21.8495 37.692 20.5475 38.616 18.6855 38.616ZM20.7575 45.266C22.5635 45.266 23.5855 44.888 23.5855 44.16C23.5855 43.446 22.5635 43.068 20.7575 43.068C18.9515 43.068 17.9295 43.446 17.9295 44.16C17.9295 44.888 18.9515 45.266 20.7575 45.266ZM19.3995 40.478V42.046C19.8055 41.99 20.2675 41.962 20.7575 41.962C23.4175 41.962 25.0415 42.774 25.0415 44.16C25.0415 45.56 23.4175 46.372 20.7575 46.372C18.0975 46.372 16.4735 45.56 16.4735 44.16C16.4735 43.376 17.0055 42.774 17.9435 42.396V40.562C16.8095 40.618 15.7315 40.632 14.7935 40.632L14.6115 39.484C16.9355 39.484 20.0715 39.456 22.7455 39.064L22.8435 40.072C21.7095 40.282 20.5475 40.394 19.3995 40.478ZM33.8744 43.656H38.9004V44.846H27.4484V43.656H32.4324V40.674H28.8484V34.668H37.5004V35.83H30.2904V39.512H37.6124V40.674H33.8744V43.656ZM43.7293 42.27C44.8213 42.27 45.5633 41.094 45.5633 39.092C45.5633 37.132 44.8213 35.942 43.7293 35.942C42.6513 35.942 41.9093 37.132 41.9093 39.092C41.9093 41.094 42.6513 42.27 43.7293 42.27ZM49.3713 33.702H50.8273V46.386H49.3713V39.596H46.9213C46.7533 42.046 45.4653 43.558 43.7293 43.558C41.8673 43.558 40.5373 41.836 40.5373 39.092C40.5373 36.376 41.8673 34.64 43.7293 34.64C45.4233 34.64 46.7113 36.096 46.9073 38.42H49.3713V33.702ZM57.8907 37.006C57.8907 38.042 58.7027 38.728 59.8227 38.728C60.9147 38.728 61.7267 38.042 61.7267 37.006C61.7267 35.97 60.9147 35.284 59.8227 35.284C58.7027 35.284 57.8907 35.97 57.8907 37.006ZM65.3667 36.25H63.0007C63.0707 36.488 63.0987 36.74 63.0987 37.006C63.0987 37.244 63.0707 37.496 63.0147 37.72H65.3667V36.25ZM65.3667 38.854H62.4127C61.8387 39.512 60.9007 39.918 59.8227 39.918C57.9187 39.918 56.5187 38.7 56.5187 37.006C56.5187 35.298 57.9187 34.094 59.8227 34.094C60.8867 34.094 61.7967 34.472 62.3847 35.116H65.3667V33.702H66.8227V40.128H65.3667V38.854ZM60.0327 45.07H67.2427V46.204H58.6047V42.886H65.3947V41.85H58.5907V40.73H66.8227V43.95H60.0327V45.07ZM69.9436 35.046H75.9356C75.9356 38.812 74.4236 42.004 70.0836 44.104L69.3136 42.956C72.6316 41.36 74.1996 39.134 74.4516 36.222H69.9436V35.046ZM78.2176 33.716H79.6596V46.358H78.2176V33.716Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 25,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H54V4.10821H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 1.35257C29 0.605867 29.6076 0 30.3579 0H52.6403C53.3906 0 53.9991 0.605867 53.9991 1.35257V2.70426C53.9991 3.45096 53.3906 4.05594 52.6403 4.05594H30.3579C29.6076 4.05594 29 3.45096 29 2.70426V1.35257Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 22,
    width: 25,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22.9297H54V27.0414H29V22.9297Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 24.337C29 23.5912 29.6076 22.9854 30.3579 22.9854H52.6403C53.3906 22.9854 53.9991 23.5912 53.9991 24.337V25.6896C53.9991 26.4363 53.3906 27.0413 52.6403 27.0413H30.3579C29.6076 27.0413 29 26.4363 29 25.6896V24.337Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0527 21.2465V21.917H52.6396V5.15112H39.0527V6.33274C42.2079 7.35669 44.4878 10.3081 44.4878 13.79C44.4878 17.2711 42.2079 20.2225 39.0527 21.2465ZM50.4659 11.6261C50.1656 11.6261 49.9229 11.8688 49.9229 12.1673V15.1417C49.9229 15.4402 50.1656 15.6829 50.4659 15.6829C50.7662 15.6829 51.0098 15.4402 51.0098 15.1417V12.1673C51.0098 11.8688 50.7662 11.6261 50.4659 11.6261Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6074 20.5512C32.8562 20.5512 29.8145 17.5245 29.8145 13.791C29.8145 10.0574 32.8562 7.03076 36.6074 7.03076C40.3596 7.03076 43.4013 10.0574 43.4013 13.791C43.4013 17.5245 40.3596 20.5512 36.6074 20.5512ZM39.7776 13.791C39.7776 13.4916 39.5349 13.2498 39.2346 13.2498H35.4745L36.7199 12.0097C36.9325 11.7989 36.9325 11.4561 36.7199 11.2453C36.5082 11.0336 36.1637 11.0336 35.952 11.2453L33.9696 13.217C33.6516 13.5341 33.6516 14.047 33.9696 14.3641L35.952 16.3367C36.1637 16.5475 36.5082 16.5475 36.7199 16.3367C36.9325 16.125 36.9325 15.7822 36.7199 15.5714L35.4745 14.3313H39.2346C39.5349 14.3313 39.7776 14.0895 39.7776 13.791Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 9,
    width: 4,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0977 9.91162H51.3741V15.841H48.0977V9.91162Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0977 9.91162H51.4193V15.8906H48.0977V9.91162Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 16,
    width: 12,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0898 16.9834H51.3755V22.1102H40.0898V16.9834Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0898 16.9834H51.3834V22.1652H40.0898V16.9834Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 7,
    width: 15,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7539 7.04443H43.3593V20.6499H29.7539V7.04443Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7539 13.8472C29.7539 10.0906 32.8001 7.04443 36.5566 7.04443C40.3132 7.04443 43.3593 10.0906 43.3593 13.8472C43.3593 17.6037 40.3132 20.6499 36.5566 20.6499C32.8001 20.6499 29.7539 17.6037 29.7539 13.8472Z",
    fill: "black"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3834 13.0202C38.5986 13.0202 36.8111 13.0202 35.0254 13.0202C35.3443 12.7013 35.6623 12.3833 35.9803 12.0654C36.7146 11.331 35.571 10.1955 34.8341 10.9333C34.0581 11.7093 33.2822 12.4852 32.5063 13.2611C32.1936 13.5738 32.2016 14.092 32.5116 14.3994C33.2875 15.1753 34.0635 15.9512 34.8394 16.7272C35.5746 17.4615 36.7093 16.3179 35.9714 15.581C35.6561 15.2656 35.3381 14.9476 35.0227 14.6323C36.8049 14.6323 38.588 14.6323 40.3701 14.6323C41.4118 14.6323 41.4198 13.0202 40.3834 13.0202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 18,
    width: 3,
    height: 3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.582 18.8042H46.9515V20.3986H44.582V18.8042Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3103_4015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3103_4015",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 18,
    width: 3,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3271 18.8042H46.1465C46.5566 18.8042 46.8896 19.1372 46.8896 19.5474C46.8896 19.9575 46.5566 20.2905 46.1465 20.2905H45.3271C44.917 20.2905 44.584 19.9575 44.584 19.5474C44.584 19.1372 44.917 18.8042 45.3271 18.8042Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3103_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.584 18.8042H46.8427V20.2657H44.584V18.8042Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpened);
export default __webpack_public_path__ + "static/media/opened.fb3286dd081357bf0771b44af6038534.svg";
export { ForwardRef as ReactComponent };